var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',{staticClass:"display-1 font-weight-bold mb-3"},[_vm._v("\n    This is an about System "+_vm._s(_vm.$route.params.id)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }